// Angular
import { inject, Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";

// RXJS/Store
import { Store } from "@ngrx/store";
import * as LoginStore from "../../login/store";
import { AUTHENTICATION_SERVICE, ClToken2Service } from "@carnegie-learning/data-access-angular-fido";
import { AuthenticationService } from "@carnegie-learning/data-access-fido";
import { Actions, ofType } from "@ngrx/effects";
import { map, mergeMap, Observable, of, tap } from "rxjs";

// Services/Types/Helpers
import { LocalStorage } from "#services/local-storage.service";
import { PPUser } from "cli-types";

@Injectable({providedIn: 'root'})
export class AuthTokenGuardService  {
    authenticationService = inject<AuthenticationService>(AUTHENTICATION_SERVICE);
    clToken2Service = inject(ClToken2Service);
    router = inject(Router);
    localStorage = inject(LocalStorage);
    loginStore = inject(Store<LoginStore.UserState>);
    actions$ = inject(Actions);

    constructor() {}

    canActivate(): Observable<boolean | UrlTree> {
        return this.whoamiV2();
    }

    canActivateChild(): Observable<boolean | UrlTree> {
        return this.whoamiV2();
    }

    whoamiV2(): Observable<boolean | UrlTree> {
        return this.authenticationService.whoamiV2().pipe(
            tap((response) => {
                if (response && response.authToken) {
                    this.clToken2Service.setClToken2(response.authToken);
                }
            }),
            mergeMap((response) => {
                const userData: PPUser = this.localStorage.get("userProfile");
                if (response?.userId === userData?.userGUID || ((<any>window).isDemo && !!response?.userId && !!userData?.userGUID)) {//If the user is in demo, switching between teacher and student roles, their IDs will not match.
                    return of(response);
                }
                this.loginStore.dispatch(LoginStore.userProfileAttempt());
                return this.actions$.pipe(
                    ofType(LoginStore.loadFidoUserDataSuccess),
                    map(() => response)
                );
            }),
            map(response => response?.authToken ? true : this.router.createUrlTree(["/login"]))
            );
    }
}
